import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RulebookLevelInterceptorService implements HttpInterceptor  {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // First clear cache for make work at the moment
    Object.keys(localStorage).filter(value=> value.includes('RB-ARTICLE')).forEach(value=>{
      if(value.includes('Levels=-1')==false){
        localStorage.removeItem(value);
      }
    });
    if(request.url.includes('RB-ARTICLE')){
      let req = request.clone({setParams:{'Levels':"-1"}});
      if(req.params.get('LangID') == "undefined"){
        req = req.clone({setParams:{'LangID':undefined}});
      }
      return next.handle(req);
    }
    return next.handle(request);
  }
}
